var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.component,
    _vm._b(
      { tag: "component" },
      "component",
      {
        baseApiUrl: _vm.baseApiUrl,
        model: _vm.model,
        list: _vm.list,
        listKey: _vm.listKey
      },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }